// Auth actions
export const LOG_IN = "LOG_IN";
export const LOG_OUT = "LOG_OUT";
export const AUTH_ERROR = "AUTH_ERROR";
export const AUTH_ERROR_CLEAR = "AUTH_ERROR_CLEAR";

// User actions
export const ADD_USERS = "ADD_USERS";
export const LOAD_USERS = "LOAD_USERS";
export const ADD_CURRENT_USER = "ADD_CURRENT_USER";
export const LOAD_CURRENT_USER = "LOAD_CURRENT_USER";
export const DELETE_USER = "DELETE_USER";
export const ADD_ME = "ADD_ME";
export const DELETE_ME = "DELETE_ME";
export const ADD_USER_SERVERS = "ADD_USER_SERVERS";
export const LOAD_USER_SERVERS = "LOAD_USER_SERVERS";
export const DELETE_USER_SERVERS = "DELETE_USER_SERVERS";

// Server actions
export const ADD_SERVER = "ADD_SERVER";
export const REMOVE_SERVER = "REMOVE_SERVER";
export const ADD_SERVER_USERS = "ADD_SERVER_USERS";
export const ADD_SERVER_USER = "ADD_SERVER_USER";
export const DELETE_SERVER_USER = "DELETE_SERVER_USER";
export const ADD_SERVERS = "ADD_SERVERS";
export const LOAD_SERVERS = "LOAD_SERVERS";
export const UPDATE_SERVER = "UPDATE_SERVER";
export const ADD_CURRENT_SERVER = "ADD_CURRENT_SERVER";
export const LOAD_CURRENT_SERVER = "LOAD_CURRENT_SERVER";
export const ADD_SERVER_USERS_V2 = "ADD_SERVER_USERS_V2";
export const LOAD_SERVER_USERS = "LOAD_SERVER_USERS";

// Port actions
export const ADD_SERVER_PORTS = "ADD_SERVER_PORTS";
export const LOAD_SERVER_PORTS = "LOAD_SERVER_PORTS";
export const DELETE_SERVER_PORTS = "DELETE_SERVER_PORTS";
export const ADD_SERVER_PORT = "ADD_SERVER_PORT";
export const DELETE_SERVER_PORT = "DELETE_SERVER_PORT";
export const ADD_SERVER_PORT_USAGE = "ADD_SERVER_PORT_USAGE";
export const ADD_SERVER_PORT_USERS = "ADD_SERVER_PORT_USERS";
export const ADD_SERVER_PORT_USER = "ADD_SERVER_PORT_USER";
export const DELETE_SERVER_PORT_USER = "DELETE_SERVER_PORT_USER";
export const ADD_SERVER_PORT_FORWARD_RULE = "ADD_SERVER_PORT_FORWARD_RULE";
export const DELETE_SERVER_PORT_FORWARD_RULE = "DELETE_SERVER_PORT_FORWARD_RULE";
export const GET_TLS_PROVIDER_PORT = "GET_TLS_PROVIDER_PORT";

export const ADD_TODO = "ADD_TODO";
export const TOGGLE_TODO = "TOGGLE_TODO";
export const SET_FILTER = "SET_FILTER";

export const SHOW_BANNER = "SHOW_BANNER";
export const CLEAR_BANNER = "CLEAR_BANNER";

export const ADD_ARTIFACTS = "ADD_ARTIFACTS";
